import { MapPin, Truck, Calendar } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";
import { carDetailsLabels } from "@/i18n";

interface DeliveryFeeZones {
  zoneA: number;
  zoneB: number;
  zoneC: number;
  zoneD: number;
}

interface DeliveryInfoProps {
  location: string;
  deliveryFee?: DeliveryFeeZones;
}

const DeliveryInfo = ({ location, deliveryFee }: DeliveryInfoProps) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const { language } = useLanguage();
  const d = carDetailsLabels(language).delivery;

  return (
    <div className="space-y-4">
      <div
        className={`${
          isDark
            ? "bg-black/20 backdrop-blur-sm"
            : "bg-gray-50/80 backdrop-blur-sm"
        } p-4 rounded-lg`}
      >
        <div className="flex items-center gap-3 mb-3">
          <Truck className="w-5 h-5 text-accent" />
          <h3
            className={`font-medium ${isDark ? "text-white" : "text-gray-800"}`}
          >
            {d.deliveryOptions}
          </h3>
        </div>
        <ul className="space-y-2">
          <li className="flex items-center justify-between text-primary/60">
            <div className="flex flex-col w-full">
              <div className="flex flex-row justify-between w-full">
                <span>{d.pickupOnSite}</span>
                <span className="font-medium text-green-500">{d.free}</span>
              </div>
              <div className="flex flex-row gap-2">
                <MapPin className="w-4 h-4 text-accent" />
                <p className="text-accent">{location}</p>
              </div>
            </div>
          </li>

          <li className={`flex items-center justify-between text-primary/60`}>
            <span>{d.zoneA}</span>
            <span className="font-medium">
              {deliveryFee?.zoneA
                ? deliveryFee.zoneA.toLocaleString("sv-SE")
                : "N/A"}{" "}
              kr
            </span>
          </li>
          <li className={`flex items-center justify-between text-primary/60`}>
            <span>{d.zoneB}</span>
            <span className="font-medium">
              {deliveryFee?.zoneB
                ? deliveryFee.zoneB.toLocaleString("sv-SE")
                : "N/A"}{" "}
              kr
            </span>
          </li>
          <li className={`flex items-center justify-between text-primary/60`}>
            <span>{d.zoneC}</span>
            <span className="font-medium">
              {deliveryFee?.zoneC
                ? deliveryFee.zoneC.toLocaleString("sv-SE")
                : "N/A"}{" "}
              kr
            </span>
          </li>
          <li className={`flex items-center justify-between text-primary/60`}>
            <span>{d.zoneD}</span>
            <span className="font-medium">{d.priceOnRequest}</span>
          </li>
        </ul>
      </div>

      <div
        className={`${
          isDark
            ? "bg-black/20 backdrop-blur-sm"
            : "bg-gray-50/80 backdrop-blur-sm"
        } p-4 rounded-lg`}
      >
        <div className="flex items-center gap-3 mb-3">
          <Calendar className="w-5 h-5 text-accent" />
          <h3
            className={`font-medium ${isDark ? "text-white" : "text-gray-800"}`}
          >
            {d.deliveryTime}
          </h3>
        </div>
        <p className={"text-primary/60"}>{d.uponWonAuction}</p>
      </div>
    </div>
  );
};

export default DeliveryInfo;
